import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { eAppContext } from '../models/global/class.global';
import { MainblockModel, BlockItem, BlockFile, BlockTree } from '../models/blocked';
import { HttpService, CoreService } from '../services';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-gestion-electronique-documents',
  templateUrl: './gestion-electronique-documents.component.html',
  styleUrls: ['./gestion-electronique-documents.component.css']
})
export class GEDComponent implements OnInit {
  public GED: BlockItem = new BlockItem();

  // tslint:disable-next-line:no-input-rename
  public singleMode: boolean = false;
  @Input('singleMode') set SetSingleMode(value: string | boolean) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.singleMode = true;
    } else {
      this.singleMode = value;
    }
  }
  //@Input('files') set SetFiles(value: Array<BlockFile>) { this.files = value; }
  @Output() selectChange: EventEmitter<Array<BlockFile>> = new EventEmitter<Array<BlockFile>>();
  @Output() fileClicked: EventEmitter<BlockFile> = new EventEmitter<BlockFile>();

  public files: Array<BlockFile> = [];
  constructor(
    private http: HttpService,
    private indParam: CoreService
  ) { }


  ngOnInit(): void {
    if (this.indParam.Context === eAppContext.QUEOVAL) {
 this.http.getHttp<MainblockModel>(`${this.indParam.AppParams.apiUrl}api/mainblocks/getData/GET_EXPLORER_FILES/0`).subscribe(
      (result: MainblockModel) => {
        this.GED = result.BlockData;

       // this.files
      });
    }
   
  }

  public GedFolderClicked(element: HTMLDivElement, block: BlockTree) {
    block.IsVisible = true;
    element.classList.toggle("active");
    const panel: any = (element.nextElementSibling as HTMLDivElement);
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = "100000000000000000000000000000000000000000000000000000000000px";
    }
  }

  public ToggleFile(event: any, file: BlockFile): void {
    event.stopPropagation();
    if (this.singleMode) {
      let toggled: boolean = false;
      this.files.forEach((f: BlockFile) => {
        if (f.value == file.value)
          toggled = true;
        f.selected = false;
      });
      if (!toggled) {
        file.selected = true;
        this.files = [file];
      } else {
        file.selected = false;
        this.files = [];
      }
    } else {
      const index: number = this.files.findIndex(f => f.value === file.value && f.key === file.key);
      if (index > -1) {
        file.selected = false;
        this.files.splice(index, 1);
      } else {
        file.selected = true;
        this.files.push(file);
      }
    }
    this.selectChange.emit(this.files);
    this.fileClicked.emit(file);
  }

}
